import { Link } from '@inertiajs/react'
import { ChevronRight } from '@/components/ui/icons'

export interface BreadcrumbItem {
  label: string
  href?: string
  onClick?: () => void
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm font-light flex-wrap">
      {items.map((item, i) => {
        const isLast = i === items.length - 1

        return (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} className="text-border-divider shrink-0" />}
            {isLast ? (
              <span className="text-muted truncate max-w-[200px]" aria-current="page">
                {item.label}
              </span>
            ) : item.onClick ? (
              <button
                onClick={item.onClick}
                className="inline-flex items-center min-h-11 text-muted hover:text-body transition-colors duration-200 truncate max-w-[200px]"
              >
                {item.label}
              </button>
            ) : item.href ? (
              <Link
                href={item.href}
                className="inline-flex items-center min-h-11 text-muted hover:text-body transition-colors duration-200 truncate max-w-[200px]"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-muted truncate max-w-[200px]">{item.label}</span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
